import { PRODUCT } from "constants/action-types";
import moment from "moment";

export const fetch = (
    id: string,
    force = false,
    options: { effectiveDate?: number | string; forceViewDisabled?: boolean } = {},
) => {
    return {
        payload: {
            id,
            force,
            options,
        },
        type: PRODUCT.FETCH.INIT,
    };
};

/** @deprecated fetchReplenishments should be used instead */
export const fetchWarehouseInventoryForProduct = (
    productId: string,
    warehouseId: string,
    timestamp = moment.utc().valueOf(),
    options?: { fromRef?: string; forRef?: string },
) => ({
    payload: { productId, warehouseId, timestamp, ...options },
    type: PRODUCT.WAREHOUSE.INVENTORY.FETCH.START,
});

/** @deprecated fetchReplenishments should be used instead */
export const fetchWarehouseReplenishmentsForProduct = (productId: string, warehouseId: string) => ({
    payload: { productId, warehouseId },
    type: PRODUCT.WAREHOUSE.REPLENISHMENTS.FETCH.START,
});

export const fetchWarehousesForProduct = (
    productId: string,
    params?: { warehouse?: string; populateReplenishments?: boolean },
) => ({
    payload: { productId, params },
    type: PRODUCT.WAREHOUSES.FETCH.START,
});

export const fetchWarehouseAvailabilityForProduct = (productId: string, warehouseId: string) => ({
    payload: { productId, warehouseId },
    type: PRODUCT.WAREHOUSE.AVAILABILITY.FETCH.START,
});
